import AuthSideImg from "./AuthSideImg";
import "./Login.css";
import { NavLink, useNavigate } from "react-router-dom";
import PasswordInput from "../../components/PasswordInput";
import { useState } from "react";
import usePostRequest from "../../hooks/usePostRequest";
import { API_ENDPOINTS, aspetto_logo } from "../../constant/_constant";
import { IconUser, IconUserQuestion, IconUsers } from "@tabler/icons-react";
import { Form, InputGroup } from "react-bootstrap";
import { toast } from "react-toastify";
import OtpVerfication from "./OtpVerfication";

function Login() {
  const [validated, setValidated] = useState(false);
  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });
  const [errors, setErrors] = useState({
    username: "",
    password: "",
  });
  const navigate = useNavigate();
  const [showOtp, setShowOtp] = useState(false);

  const { isLoading, postData } = usePostRequest(API_ENDPOINTS.LOGIN);

  const handleChange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));

    setErrors((prevState) => ({ ...prevState, [e.target.name]: "" }));
  };

  const onSuccess = (response) => {
    // toast.success("Logged in successfully.");
    // setFormData({
    //    username: "",
    //   password: "",
    // });
    setShowOtp(true)
    setValidated(false);
    // localStorage.setItem("token", response?.access_token);
    // navigate("/dashboard");
  };

  const onError = (error) => {
    toast.error(error.message || "Something went wrong!");
    if (error.errors) {
      toast.error(error?.errors?.message);
      setErrors({
        username: "",
        password: "",
        ...error.errors,
      });
    }

    setValidated(false);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    setValidated(true);

    if (form.checkValidity() === true) {
      postData(formData, onSuccess, onError);
    }
  };

  const handleNavigate = (path) => {
    navigate(path);
  };

  return (
    <div className="row g-0 flex-fill">
      <OtpVerfication show={showOtp} onClose={() => setShowOtp(false)} formData={formData}  />
      <div className="col-12 col-lg-6 col-xl-4 border-top-wide border-warning d-flex flex-column justify-content-center">
        <div className="container container-tight my-5 px-lg-5">
          <div className="text-center w-50 mb-3 m-auto">
            <img src={aspetto_logo} height={80} alt="aspetto_logo" />
          </div>
          <h2 className="heading_login text-center mb-3">
            Login to employee account
          </h2>
          <Form
            noValidate
            validated={validated}
            autoComplete="off"
            onSubmit={handleSubmit}
          >
            <Form.Group className="mb-3" controlId="email">
              <Form.Label className="required">
                Username/Email
                <span className="form-label-description">
                  <NavLink to="/forgot-username">Forgot Username or Email</NavLink>
                </span>
              </Form.Label>
              <InputGroup>
                <Form.Control
                  type="text"
                  placeholder="Enter Username or Email"
                  name="username"
                  required
                  onChange={handleChange}
                  value={formData.username}
                  isInvalid={!!errors.username}
                />
                <InputGroup.Text>
                  <IconUser stroke={1} />
                </InputGroup.Text>
                <Form.Control.Feedback type="invalid">
                  {errors.username || "Please enter username"}
                </Form.Control.Feedback>
              </InputGroup>
            </Form.Group>
            <PasswordInput
              value={formData.password}
              onChange={handleChange}
              name="password"
              placeholder="******"
              required={true}
              type="login"
              errors={errors?.password}
              customHeading="Password"
            />
            <div className="mb-2">
              <label className="form-check">
                <input type="checkbox" className="form-check-input" />
                <span className="form-check-label" style={{ color: "#212529" }}>
                  Remember me on this device
                </span>
              </label>
            </div>
            <div className="form-footer">
              <button
                type="submit"
                className={`btn btn-theme w-100 ${isLoading ? "btn-loading" : ""
                  }`}
                disabled={isLoading}
              >
                Sign in
              </button>
            </div>
          </Form>
          <div className="text-center text-secondary mt-3">
            Need an Account?{" "}
            <NavLink to="/register" tabIndex={-1}>
              Sign up
            </NavLink>
          </div>
          {/* <div className="row mt-4 btn_group">
            <div className="col">
              <button
                className="btn btn-outline-secondary w-100"
                onClick={() => handleNavigate("#")}
              >
                <IconUserQuestion className="icon text-x" />
                DHS-CBP Customers?
              </button>
            </div>
            <div className="col">
              <button
                className="btn btn-outline-secondary w-100"
                onClick={() => handleNavigate("/forgot-username")}
              >
                <IconUsers className="icon text-x" />
                Forgot UserName?
              </button>
            </div>
          </div> */}
        </div>
      </div>
      <AuthSideImg />
    </div>
  );
}

export default Login;
